export default __webpack_public_path__ + "static/media/EARNtoken.c2ddaad2.svg";